import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ModalController } from '@ionic/angular';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { UserService } from 'src/app/services/user.service';
import { TranslationService } from 'src/app/services/translation.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppInstance } from 'src/app/services/app-instance.service';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-desktop-redirect',
  templateUrl: './desktop-redirect.page.html',
  styleUrls: ['./desktop-redirect.page.scss'],
})
export class DesktopRedirectPage implements OnInit {
  public link = environment.host;
  languages: string[] = [];
  public selectedLanguage = this.languageService.getLanguage() ?? 'fi';
  public appInstanceName = '';
  public appInstanceLogo = '';
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    public languageService: LanguageService,
    public translate: TranslateService,
    private router: Router,
    private modalController: ModalController,
    private gtmService: GoogleTagManagerService,
    private userService: UserService,
    private imageService: ImageService,
    private translationService: TranslationService,
  ) {
    this.languages = this.languageService.getLanguages();
  }

  ngOnInit() {
    this.userService.appInstanceSettingsObservable
      .pipe(takeUntil(this.destroyed$))
      .subscribe((settings: AppInstance) => {
        this.appInstanceName = this.translationService.getTranslationFromLanguage(
          settings,
          this.selectedLanguage,
        ).name;
        const imageId = settings.logo;
        this.appInstanceLogo = this.imageService.getUrlById(imageId);
      });
    const language = this.languageService.getInitialLanguage();
    this.selectLanguage(language);
  }

  dismissModal = () => {
    this.gtmService
      .pushTag({
        event: 'desktopDialogClosed',
      })
      .finally(() => {
        this.modalController.dismiss();
      });
  };

  selectLanguage = (language: string) => {
    this.languageService.setLanguage(language);
    this.selectedLanguage = language;
    this.appInstanceName = this.translationService.getTranslationFromLanguage(
      this.userService.user.appInstance,
      this.selectedLanguage,
    ).name;
  };

  navigateToPrivacyPolicy(language: string) {
    this.router.navigate([language, 'privacy-policy']);
    this.dismissModal();
  }
}
